import { render, staticRenderFns } from "./ChatSuccessRateDetail.vue?vue&type=template&id=083254e7&scoped=true"
import script from "./ChatSuccessRateDetail.vue?vue&type=script&lang=js"
export * from "./ChatSuccessRateDetail.vue?vue&type=script&lang=js"
import style0 from "./ChatSuccessRateDetail.vue?vue&type=style&index=0&id=083254e7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083254e7",
  null
  
)

export default component.exports